import Api from '@/services/Api'

export default {
  getUsers() {
    return Api().get('users').then(function (response) {
      return(response)
    })
  },
  getUsersByCampaign(campaignId) {
    return Api().get(`campaigns/${campaignId}/users`).then(function (response) {
      return(response)
    })
  },
  getProfile(id) {
    return Api().get(`user-profiles/${id}`).then(function (response) {
        return(response)
      })
  },
  addUser(data) {
    return Api().post('users',data).then(function (response) {
      return (response)
    })
  },
  getUserById(id) {
    return Api().get(`users/${id}`).then(function (response) {
      return (response)
    })
  },
  partialUpdate(id, data) {
    return Api().patch(`users/${id}`, data).then(function (response) {
      return (response)
    })
  },
  update(data) {
    return Api().put(`users/${data.id}`, data).then(function (response) {
      return (response)
    })
  },
  addUserToCampaign(campaignId, userId) {
    return Api().post(`campaigns/${campaignId}/campaign-rights/${userId}`).then(function (response) {
      return (response)
    })
  },
  updatePassword(userId, data) {
    return Api().patch(`users/${userId}/password`, data).then(function (response) {
      return (response)
    })
  },
  removeUserFromCampaign(campaignId, userId) {
    return Api().patch(`campaigns/${campaignId}/campaign-rights/${userId}`).then(function (response) {
      return (response)
    })
  }
}